import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";

const Realisations = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/portfolio").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="pt-32">
      <section className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="text-sm uppercase tracking-[0.3em] text-primary mb-5">Le portfolio</p>
          <h1 className="font-serif-display text-5xl sm:text-6xl font-light max-w-3xl leading-tight">Objets & lots fabriqués sur demande</h1>
          <p className="mt-6 text-lg text-foreground/70 max-w-2xl leading-relaxed">
            Chaque réalisation naît d'une rencontre : une famille, un souvenir, un besoin précis. Voici quelques
            créations imaginées pour des particuliers et des établissements.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-12 rounded-[2.5rem] overflow-hidden border border-warm/25 shadow-[0_20px_60px_rgb(0,0,0,0.08)] grain" data-testid="realisations-banner">
            <img src="/affiche-realisations.jpg" alt="L'étagère de l'atelier : boîte gravée, coussin brodé, photo de famille et cœur en résine, veillés par une gardienne à la lanterne" className="w-full h-auto block" />
          </div>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {items.map((it, i) => (
            <Reveal key={it.id} delay={(i % 3) * 0.06}>
              <article data-testid={`portfolio-item-${it.id}`} className="break-inside-avoid group relative overflow-hidden rounded-3xl">
                <img src={it.image} alt={it.title} className="w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-foreground/10 to-transparent opacity-90" />
                <div className="absolute bottom-0 p-7">
                  <p className="text-background/70 text-xs uppercase tracking-[0.2em]">{it.category}</p>
                  <h3 className="font-serif-display text-2xl text-background mt-2">{it.title}</h3>
                  <p className="text-background/70 text-sm mt-2 leading-relaxed">{it.description}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 pb-20 text-center">
        <Reveal>
          <h2 className="font-serif-display text-4xl sm:text-5xl font-light">Vous avez un projet en tête ?</h2>
          <p className="mt-5 text-foreground/70 max-w-xl mx-auto">Racontez-nous l'histoire et les besoins de la personne. Nous concevrons un objet ou un lot entièrement sur mesure.</p>
          <Link to="/contact" data-testid="portfolio-cta" className="inline-block mt-8 rounded-full bg-primary text-primary-foreground px-9 py-4 hover:scale-105 transition-transform duration-300">Faire une demande</Link>
        </Reveal>
      </section>
    </div>
  );
};

export default Realisations;
